import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import {  ScrollToService } from "@nicky-lenaers/ngx-scroll-to";
import * as _ from "lodash";
@Component({
  selector: "app-product-categories",
  templateUrl: "./product-categories.component.html",
  styleUrls: ["./product-categories.component.scss"],
})
export class ProductCategoriesComponent implements OnInit {
  @Input() productCategories: any[];
  @Input() public visibleCategory: any;
  @Output() sendDataToParent = new EventEmitter<string>();

  constructor(private scrollToService: ScrollToService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: any) {
    this.scrollTo(this.visibleCategory);
    // You can also use categoryId.previousValue and 
    // categoryId.firstChange for comparing old and new values

  }
  public scrollTo(cat: string) {
    let el = document.getElementById(`${cat}1`);
    if (!_.isNil(el)){
      el.scrollIntoView();
    }
  }
  
  _sendDataToParent(data: string) {
    this.sendDataToParent.emit(data);
  }
}
